import { Component, Input, OnInit } from '@angular/core'
import { DataShareService } from '../services/datashare.service'
@Component({
  selector: 'ErroPage',
  templateUrl: "ErrorPage.component.html"

})

export class ErrorPage implements OnInit {
    Jsondata: any;
     
    public constructor(private dataShareService: DataShareService) {

    }
    ngOnInit() {
        this.dataShareService.shareDataMethod$.subscribe((data) => {
            this.Jsondata = data; 
        });
        
    }
}
